import { __decorate, __metadata } from "tslib";
import { IsBoolean } from 'class-validator';
import { SupportingDocumentsConfiguration } from '../core/SupportingDocumentsConfiguration';
/**
 * Department requirements for documents to be attached when placing an order
 */
export class DepartmentSupportingDocumentsConfiguration extends SupportingDocumentsConfiguration {
    /**
     * @param prompt Describes to the user, in plain text, that they should attach documents with their order,
     * and describes what they are
     * @param areEnabled Indicates whether documents can be attached when placing an order (currently only implemented for
     * transcript orders)
     * @param areRequired Indicate whether the user will be blocked from placing their order
     * before they upload any documents
     * @param isOverrideCourtConfig Indicate whether the department configuration will be used when placing orders
     */
    constructor(prompt, areEnabled, areRequired, isOverrideCourtConfig) {
        super(prompt, areEnabled, areRequired);
        this.isOverrideCourtConfig = isOverrideCourtConfig;
    }
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], DepartmentSupportingDocumentsConfiguration.prototype, "isOverrideCourtConfig", void 0);
